import { configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch as useAppDispatch, useSelector as useAppSelector } from 'react-redux';
import { persistStore } from 'redux-persist';
import reducers from './reducers';

const confirmMiddleware = (store: any) => (next: any) => (action: any) => {
  // Our middleware
  if (action.type === 'dialog/setDialogResult' && action.payload) {
    if (store.getState().dialog.dialogFunction) {
      return store.getState().dialog.dialogFunction();
    }
  }
  // call the next function
  next(action);
};

const store = configureStore({
  reducer: reducers,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false
    }).concat(confirmMiddleware)
});

export type RootState = ReturnType<typeof reducers>;

export type AppDispatch = typeof store.dispatch;

const persister = persistStore(store);

const { dispatch } = store;

const useDispatch = () => useAppDispatch<AppDispatch>();
const useSelector: TypedUseSelectorHook<RootState> = useAppSelector;

export { dispatch, persister, store, useDispatch, useSelector };
